import React from 'react';
import { MapPin, Users, Wrench } from 'lucide-react';

const benefits = [
  {
    icon: MapPin,
    title: 'Local Presence in China',
    description:
      'Faster mobilization and local coordination for projects throughout China.',
  },
  {
    icon: Users,
    title: 'Flexible Project Support',
    description:
      'From individual specialists to project teams for short-term and long-term assignments.',
  },
  {
    icon: Wrench,
    title: 'Experienced Technical Personnel',
    description:
      'Engineers and supervisors with hands-on experience in industrial installation, commissioning and project execution.',
  },
];

export const ValueProposition = () => {
  return (
    <section
      id="value-proposition"
      data-testid="value-proposition-section"
      className="py-24 bg-white border-b border-gray-100"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-14">
            <h2
              data-testid="value-proposition-headline"
              className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight"
            >
              Your Project in China.{' '}
              <span className="text-blue-700">Our Support on Site.</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-blue-800 mb-8"></div>

            <div className="space-y-5 max-w-4xl">
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                Tower Technology provides experienced engineers, supervisors and technical specialists for industrial projects throughout China.
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
                We support machinery manufacturers, plant engineering companies and industrial contractors during installation, commissioning and project execution — providing qualified technical personnel directly where they are needed.
              </p>
            </div>
          </div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mt-12">
            {benefits.map((benefit, idx) => {
              const Icon = benefit.icon;
              return (
                <div
                  key={idx}
                  data-testid={`value-benefit-${idx}`}
                  className="bg-gradient-to-br from-blue-50 to-gray-50 border border-blue-100 rounded-xl p-8 hover:shadow-lg hover:border-blue-200 transition-all duration-300"
                >
                  <div className="w-12 h-12 rounded-lg bg-blue-700 flex items-center justify-center mb-5">
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-sm font-bold tracking-wider text-blue-800 uppercase mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-base text-gray-700 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
